<ng-template [spinnerLoader]="modelResource.isLoading()" [size]="'sm'"></ng-template>

<label for="modelSelect" class="form-label">Modello</label>
<select id="modelSelect" class="form-select" [value]="value()?.id ?? ''" [disabled]="disabled()" (change)="onSelectionChange($event)" (blur)="onBlur()" [class.is-invalid]="isInvalid()">
    <option value="" selected>Tutti i tipi</option>
    @for (item of modelResource.value(); track item.id) {
        <option [value]="item.id">{{ item.name }}</option>
    }
</select>
@for (error of errors(); track $index) {
    <div class="invalid-feedback">{{ error.message }}</div>
}